export default "__VITE_ASSET__BPU56dmL__"